// src/components/BackButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function BackButton({ toFallback = '/dashboard', variant = 'text', sx = {} }) {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(toFallback);
    }
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      variant={variant}
      onClick={goBack}
      sx={{ minWidth: 0, padding: '6px 10px', ...sx }}
      aria-label="بازگشت"
    >
      بازگشت
    </Button>
  );
}
